import React, { useState } from 'react'

import i18n from 'live/services/i18n'
import { EnvPropertiesContainer } from './styles'
import { UpdateEnvProperties } from './components'

export const EnvProperties: React.FC = () => {

    return (
        <EnvPropertiesContainer>
            <UpdateEnvProperties />
            <div className="info-label">
                <i className="fal fa-info-circle"></i>
                <span className="label-env">{i18n('After changing the value of the property, you need to')}
                    <span>{i18n(' restart the plugin ')}</span>
                {i18n('that uses it.')}</span>
            </div>
        </EnvPropertiesContainer>
    )
}
